export default __webpack_public_path__ + "static/media/football-1.61e61e0a.jpg";